import { Button, Code, CopyButton, Group } from '@mantine/core';
import { formatDate } from './format';
import { color } from './tokens';

export interface InviteLinkProps {
  email: string;
  inviteUrl: string;
  expiresAt: string;
  /** The link was also emailed to `email`; false while email is off. */
  emailed: boolean;
  onDone: () => void;
}

/**
 * A just-created invite link, shown once, with a copy button: the fallback
 * when the invite email is slow or lost, and the only way to pass it on
 * while email is off.
 */
export function InviteLink({ email, inviteUrl, expiresAt, emailed, onDone }: InviteLinkProps) {
  const until = formatDate(expiresAt);
  return (
    <div aria-label="Invite link" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
      <span style={{ fontSize: 14, color: color.textBody }}>
        {emailed
          ? `We emailed this link to ${email}. You can also copy it and send it yourself. It is shown once and works until ${until}.`
          : `Email is off, so send this link to ${email} yourself. It is shown once and works until ${until}.`}
      </span>
      <Code block style={{ wordBreak: 'break-all', whiteSpace: 'pre-wrap' }}>
        {inviteUrl}
      </Code>
      <Group justify="flex-end">
        <CopyButton value={inviteUrl}>
          {({ copied, copy }) => (
            <Button variant="default" onClick={copy}>
              {copied ? 'Copied' : 'Copy link'}
            </Button>
          )}
        </CopyButton>
        <Button color="dark" onClick={onDone}>
          Done
        </Button>
      </Group>
    </div>
  );
}
